module.exports = __webpack_public_path__ + "img/9788952745187.9785f92b.jpg";